import {Popup} from "@progress/kendo-react-popup"
import {MDBBreadcrumb, MDBBreadcrumbItem} from "mdbreact"
import {useEffect, useRef, useState} from "react"
import FeesReportFilter from "../../components/FeesReport/FeesReportFilter"
import FeesReportGrid from "../../components/FeesReport/FeesReportGrid"
import {useAppDispatch} from "../../store"
import {getUserDealersAction} from "../App/appSlice"
import {FeesReportParams, fetchFeesReport} from "../MotBooking/bookingSlice"

const FeesReport = () => {
    const dispatch = useAppDispatch()
    const getFeeReports = (feeReportParams: FeesReportParams) => dispatch(fetchFeesReport(feeReportParams))
    const infoRef = useRef<any>(null)
    const [showSearchInfo, setShowSearchInfo] = useState(false)

    useEffect(() => {
        dispatch(getUserDealersAction("MULTIPLE_DEALER"))
    }, [dispatch])

    return (
        <>
            <button
                type="button"
                className="k-button-rectangle k-button-flat k-button-flat-primary position-absolute"
                style={{top: "7.5rem", right: "0.5rem"}}
                onClick={() => setShowSearchInfo(true)}
                onMouseLeave={() => setShowSearchInfo(false)}
                ref={infoRef}
            >
                <span className="fa fa-info-circle"></span>
            </button>
            <Popup
                offset={{top: 10, left: 0}}
                anchor={infoRef.current}
                anchorAlign={{horizontal: "right", vertical: "bottom"}}
                show={showSearchInfo}
                popupClass="popup-content"
                popupAlign={{horizontal: "right", vertical: "top"}}
            >
                <dl>
                    <dt>Search</dt>
                    {[
                        "Booking Ref",
                        "Customer",
                        "Vehicle Reg",
                        "Test Station",
                        "Job Number",
                        "Customer Order",
                        "Status",
                        "Email",
                        "First Name",
                        "Last Name",
                        "Phone",
                        "Notes",
                        "Transaction Type",
                        "Test Package",
                        "Dealer Name",
                        "Account no",
                    ].map((column,i) => (
                        <li key={crypto.randomUUID()}>{column}</li>
                    ))}
                </dl>
            </Popup>
            <MDBBreadcrumb>
                <MDBBreadcrumbItem>Manage MOT</MDBBreadcrumbItem>
                <MDBBreadcrumbItem active>Reports</MDBBreadcrumbItem>
            </MDBBreadcrumb>
            <FeesReportFilter getFeeReports={getFeeReports} />
            <FeesReportGrid />
        </>
    )
}

export default FeesReport
